import NotificationsContainer from './NotificationsContainer';

export default NotificationsContainer;



// WEBPACK FOOTER //
// ./src/components/pages/User/Notifications/index.js